module.exports = [{
      plugin: require('/Users/richardhsueh/Project/ud_project/control-panel-doc-customer/node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/richardhsueh/Project/ud_project/control-panel-doc-customer/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
